import { TableContainer } from '@mui/material';
import { Table } from './styles';
import { useEffect, useState } from 'react';
import { currentCapacityOpts } from '~/helpers/driConfigOptions';
import { useTranslation } from 'react-i18next';
import { apiCall } from '~/providers';
import { stateObject } from '~/helpers/batchInputHelpers';
import { toast } from 'react-toastify';

interface PreFillGuideProps {
   typeOfSolution: string;
   comboOpts: ReturnType<typeof stateObject>['comboOpts'];
   energyOpts: ReturnType<typeof stateObject>['energyOpts'];
}

export const PreFillGuide = ({ typeOfSolution, comboOpts, energyOpts }: PreFillGuideProps): JSX.Element => {
  const { t } = useTranslation();
  const [unitMachine] = useState<string[]>([]);
  const [unitMachineIds] = useState<string[]>([]);
  const [unitMachineLabel] = useState<string[]>([]);
  const [timezoneList, setTimezonesList] = useState<{ label: string; value: number; }[]>();
  const [sensorsPressure, setSensorsPressure] = useState<{ label: string; value: string; }[]>();
  const [environmentCategories, setEnvironmentCategories] = useState<{ label: string; value: string; }[]>();
  const [utilitiesModels, setUtilitiesModels] = useState<Record<number, {
    value: number;
    name: string;
    info: {
      ID: number;
      FIELD_NAME: string;
      VALUE: string;
      MEASURE_UNIT: string;
      TYPE_FIELD: string;
    }[];
  }[]>>();
  const typeSolutionHeader = {
    unit: [
      [{ value: ' ' }],
      [{ value: 'Tipo de Solução' }],
      [{ value: 'ID da Unidade' }],
      [{ value: 'Código da Unidade - Celsius' }],
      [{ value: 'Código da Unidade - API' }],
      [{ value: 'Unidade' }],
      [{ value: 'País' }],
      [{ value: 'Estado' }],
      [{ value: 'Cidade' }],
      [{ value: 'Horário de Abertura' }],
      [{ value: 'Horário de Fechamento' }],
      [{ value: 'Exceções do Horário de Funcionamento' }],
      [{ value: 'Fuso Horário' }],
      [{ value: 'Área Construída' }],
      [{ value: 'Status da Unidade' }],
      [{ value: 'Endereço' }],
      [{ value: 'Número de Pessoas' }],
      [{ value: 'Croquis (1 - 5)' }],
      [{ value: 'SIMCARD ICCID' }],
      [{ value: 'Ponto de Acesso' }],
      [{ value: 'Modem' }],
      [{ value: 'MAC - Ponto de Acesso' }],
      [{ value: 'MAC - Repetidor' }],
      [{ value: 'Fotos (1-3) SIMCARD' }],
      [{ value: 'Documentos (1 - 5)' }],
    ],
    energy: [
      [{ value: ' ' }],
      [{ value: 'Tipo de Solução' }],
      [{ value: 'Nome da Unidade' }],
      [{ value: 'Aplicação' }],
      [{ value: 'ID do Quadro Elétrico' }],
      [{ value: 'Nome do Quadro Elétrico' }],
      [{ value: 'Tipo de Quadro' }],
      [{ value: 'ID Dispositivo Energia' }],
      [{ value: 'ID Med. Energia' }],
      [{ value: 'N. Serie Medidor' }],
      [{ value: 'Modelo Medidor' }],
      [{ value: 'Capacidade de TC (A)' }],
      [{ value: 'Tipo de Instalação Elétrica' }],
      [{ value: 'Intervalo de Envio' }],
      [{ value: 'Foto 1-5 (DRI)' }],
      [{ value: 'Ambiente Monitorado VAV' }],
      [{ value: 'Fabricante do Termostato' }],
      [{ value: 'Modelo do Termostato' }],
      [{ value: 'Fabricante do Atuador' }],
      [{ value: 'Modelo do Atuador' }],
      [{ value: 'Tipo do Atuador' }],
      [{ value: 'Fabricante da Caixa VAV' }],
      [{ value: 'Modelo da Caixa VAV' }],
      [{ value: 'Fabricante do Fancoil' }],
      [{ value: 'Modelo do Fancoil' }],
      [{ value: 'Status do Dispositivo' }],
    ],
    water: [
      [{ value: ' ' }],
      [{ value: 'Tipo de Solução' }],
      [{ value: 'Unidade' }],
      [{ value: 'ID DMA' }],
      [{ value: 'Hidrômetro' }],
      [{ value: 'Local de Instalação' }],
      [{ value: 'Data de Instalação do DMA' }],
      [{ value: 'Capacidade Total dos Reservatórios (L)' }],
      [{ value: 'Total de Reservatórios' }],
      [{ value: 'Foto (1-5) DMA' }],
      [{ value: 'Status do Dispositivo' }],
    ],
    machine: [
      [{ value: ' ' }],
      [{ value: 'Tipo de Solução' }],
      [{ value: 'Unidade' }],
      [{ value: 'ID da Máquina' }],
      [{ value: 'Nome da Máquina' }],
      [{ value: 'Tag de Identificação da Máquina' }],
      [{ value: 'Máquina Instalada em' }],
      [{ value: 'Aplicação' }],
      [{ value: 'Tipo de Equipamento' }],
      [{ value: 'Fabricante' }],
      [{ value: 'Fluido' }],
      [{ value: 'Potência Nominal da Máquina [kW]' }],
      [{ value: 'Capacidade Frigorífica da Máquina' }],
      [{ value: 'Foto (1-5) Máquina' }],
      [{ value: 'Dispositivo de Automação (ID DUT/DAM/DRI)' }],
      [{ value: 'Posicionamento (INS/AMB/DUO)' }],
      [{ value: 'DUT DUO (POSIÇÃO SENSORES)' }],
      [{ value: 'Local de Instalação do DAM' }],
      [{ value: 'Posicionamento do DAM' }],
      [{ value: 'Sensor T0 do DAM' }],
      [{ value: 'Sensor T1 do DAM' }],
      [{ value: 'Foto (1-5) Dispositivo de Automação' }],
      [{ value: 'Dispositivo de Referência (ID DUT/DAM)' }],
      [{ value: 'Foto (1-5) Dispositivo Referência' }],
      [{ value: 'Nome do Ambiente' }],
      [{ value: 'Tipo de Ambiente' }],
      [{ value: 'ID Ativo' }],
      [{ value: 'Nome do Ativo' }],
      [{ value: 'Tag de Identificação do Ativo' }],
      [{ value: 'Função' }],
      [{ value: 'Modelo do Ativo' }],
      [{ value: 'Capacidade Frigorífica do Ativo' }],
      [{ value: 'COP' }],
      [{ value: 'Potência Nominal do Ativo [kW]' }],
      [{ value: 'Modelo da Evaporadora' }],
      [{ value: 'Velocidade de Insuflamento' }],
      [{ value: 'Corrente Nominal / RLA do Compressor [A]' }],
      [{ value: 'Alimentação do Equipamento' }],
      [{ value: 'Foto (1-5) Ativo' }],
      [{ value: 'Dispositivo Diel associado ao ativo (DAC/DUT)' }],
      [{ value: 'Comissionado (S/N)' }],
      [{ value: 'Sensor P0' }],
      [{ value: 'P0' }],
      [{ value: 'Sensor P1' }],
      [{ value: 'P1' }],
      [{ value: 'Foto (1-5) DAC' }],
      [{ value: 'Local de Instalação do Dispositivo' }],
      [{ value: 'Status do Dispositivo' }],
    ],
    environment: [
      [{ value: '' }],
      [{ value: 'Tipo de Solução' }],
      [{ value: 'Unidade' }],
      [{ value: 'Dispositivo de Referência (ID DUT/DAM)' }],
      [{ value: 'Foto (1-5) Dispositivo Referência' }],
      [{ value: 'ID do Ambiente' }],
      [{ value: 'Nome do Ambiente' }],
      [{ value: 'Tipo de Ambiente' }],
      [{ value: 'Categoria do Ambiente' }],
    ],
    utility: [
      [{ value: ' ' }],
      [{ value: 'Tipo de Solução' }],
      [{ value: 'Nome da unidade' }],
      [{ value: 'Aplicação do utilitário' }],
      [{ value: 'Id do utilitário' }],
      [{ value: 'Nome do utilitário' }],
      [{ value: 'Data de Instalação do Utilitário' }],
      [{ value: 'Fabricante do Utilitário' }],
      [{ value: 'Modelo do Utilitário' }],
      [{ value: 'Tensão da Rede (VAC)' }],
      [{ value: 'Corrente da Rede Elétrica (A)' }],
      [{ value: 'Dispositivo associado' }],
      [{ value: 'Feedback do Utilitário' }],
      [{ value: 'Porta do Utilitário' }],
      [{ value: 'Sensor de corrente' }],
      [{ value: 'Ativo associado' }],
      [{ value: 'Foto Utilitário' }],
      [{ value: 'Foto do Dispositivo do Utilitário' }],
      [{ value: 'Status do Dispositivo' }],
    ],
  };

  const required = {
    energy: [
      [{ value: 'Obrigatório' }],
      [{ value: 'Sim' }],
      [{ value: 'Sim' }],
      [{ value: 'Sim' }],
      [{ value: 'Obrigatório para edição' }],
      [{ value: 'Sim' }],
      [{ value: 'Não' }],
      [{ value: 'Obrigatório para edição' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não obrigatório para cadastro. Obrigatório caso tenha Dispositivo' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Obrigatório se Aplicação = VAV' }],
      [{ value: 'Obrigatório se Aplicação = VAV/Fancoil' }],
      [{ value: 'Obrigatório se Aplicação = VAV/Fancoil' }],
      [{ value: 'Obrigatório se Aplicação = VAV/Fancoil' }],
      [{ value: 'Obrigatório se Aplicação = VAV/Fancoil' }],
      [{ value: 'Obrigatório se Modelo do Termostato = BAC-6000 AMLN' }],
      [{ value: 'Obrigatório se Aplicação = VAV' }],
      [{ value: 'Não' }],
      [{ value: 'Obrigatório se Aplicação = Fancoil' }],
      [{ value: 'Obrigatório se Aplicação = Fancoil' }],
    ],
    machine: [
      [{ value: 'Obrigatório' }],
      [{ value: 'Sim' }],
      [{ value: 'Sim' }],
      [{ value: 'Não obrigatório para cadastro.' }, { value: 'Obrigatório para edição' }],
      [{ value: 'Sim' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não obrigatório para cadastro.' }, { value: 'Obrigatório para edição' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
    ],
    water: [
      [{ value: 'Obrigatório' }],
      [{ value: 'Sim' }],
      [{ value: 'Sim' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
    ],
    unit: [
      [{ value: 'Obrigatório' }],
      [{ value: 'Sim' }],
      [{ value: 'Apenas para edição' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Apenas para cadastro' }],
      [{ value: 'Sim' }],
      [{ value: 'Sim' }],
      [{ value: 'Sim' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Sim' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
    ],
    environment: [
      [{ value: 'Obrigatório' }],
      [{ value: 'Sim' }],
      [{ value: 'Sim' }],
      [{ value: '' }],
      [{ value: 'Não' }],
      [{ value: 'Não obrigatório para cadastro.' }, { value: 'Obrigatório para edição' }],
      [{ value: 'Sim' }],
      [{ value: 'Não' }],
      [{ value: 'Sim' }],
    ],
    utility: [
      [{ value: 'Obrigatório' }],
      [{ value: 'Sim' }],
      [{ value: 'Sim' }],
      [{ value: 'Sim' }],
      [{ value: 'Apenas para edição' }],
      [{ value: 'Apenas para criação' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
      [{ value: 'Não' }],
    ],
  };

  const restrict = {
    energy: [
      [{ value: 'Restrições' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: 'Incremental gerado pelo dash para edição.' }],
      [{ value: '' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: 'Incremental gerado pelo dash para edição.' }],
      [{ value: 'Ao colocar um dispositivo que não existe, este é criado.' }, { value: 'Deve começar com DRI' }],
      [{ value: 'Só se aplica a Medidor de Energia' }],
      [{ value: 'Deve ser um dos valores tabelados.' }, { value: 'Só se aplica a Medidor de Energia' }],
      [{ value: 'Só se aplica a Medidor de Energia.' }, { value: 'Deve ser um dos valores tabelados.' }],
      [{ value: 'Para os modelos ET330, EM330 e EM210 deve ser um dos valores tabelados' }],
      [{ value: '' }],
      [{ value: 'Ao colocar uma nova foto, a foto antiga é sobrescrita.' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: '' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: '' }],
    ],
    machine: [
      [{ value: 'Restrições' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: 'Para criar uma máquina, deve ser um nome diferente das demais máquinas.' }],
      [{ value: '' }],
      [{ value: 'A data deve estar como texto = DD/MM/AAAA' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: 'Ao colocar uma nova foto, a foto antiga é sobrescrita.' }],
      [
        { value: 'Ao colocar um dispositivo que não existe, este é criado.' },
        { value: 'O dispositivo não pode estar associado a outro cliente,  exceto quando o cliente é o fabricante.' },
        { value: 'Se for DRI, não pode automatizar mais de uma máquina.' },
        { value: 'Se for DUT, deve estar também no DUT de Referência' },
      ],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: 'Necessário apenas para Posicionamento DUO.' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: 'Deve ser um dos valores tabelados. Necessário apenas para Posicionamento do DAM DUO' }],
      [{ value: 'Deve ser um dos valores tabelados. Necessário apenas para Posicionamento do DAM DUO' }],
      [{ value: 'Ao colocar uma nova foto, a foto antiga é sobrescrita.' }],
      [{ value: 'Ao colocar um dispositivo que não existe, este é criado. ' }],
      [{ value: 'Ao colocar uma nova foto, a foto antiga é sobrescrita.' }],
      [{ value: '' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: 'Ao colocar uma nova foto, a foto antiga é sobrescrita.' }],
      [{ value: 'Ao colocar um dispositivo que não existe, este é criado.' }],
      [{ value: '' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: 'Ao colocar uma nova foto, a foto antiga é sobrescrita.' }],
      [{ value: '' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
    ],
    water: [
      [{ value: 'Restrições' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: 'Ao colocar um dispositivo que não existe, este é criado.' }, { value: 'Deve começar com DMA' }],
      [{ value: '' }],
      [{ value: 'Ao colocar um local que não existe, este é criado.' }],
      [{ value: 'Se não preencher, coloca a data atual.' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: 'Ao colocar uma nova foto, a foto antiga é sobrescrita.' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
    ],
    unit: [
      [{ value: 'Restrições' }],
      [{ value: 'Deve ser um dos valores tabelados' }],
      [{ value: 'Deve ser um dos valores tabelados' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: 'Deve ser um dos valores tabelados' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: 'Deve estar no formato' }, { value: '(Os dias sem preencher será considerado sem horário de abertura)' }, { value: 'Dom HH:MM' }, { value: 'Seg HH:MM' }, { value: 'Ter HH:MM' }, { value: 'Qua HH:MM' }, { value: 'Qui HH:MM' }, { value: 'Sex HH:MM' }, { value: 'Sab HH:MM' }],
      [{ value: 'Deve estar no formato (Os dias sem preencher será considerado sem horário de fechamento)' }, { value: 'Dom HH:MM' }, { value: 'Seg HH:MM' }, { value: 'Ter HH:MM' }, { value: 'Qua HH:MM' }, { value: 'Qui HH:MM' }, { value: 'Sex HH:MM' }, { value: 'Sab HH:MM' }],
      [{ value: 'Deve estar no formato (Se o ano não estiver preenchido será considerado que é pra se repetir anualmente)' }, { value: '10/10/2025 HH:MM-HH:MM' }, { value: '10/10 HH:MM-HH:MM' }],
      [{ value: 'Deve ser um dos valores tabelados.' }, { value: 'Lista de fuso horários com o offset entre parênteses.' }],
      [{ value: 'O valor deve estar em m²' }],
      [{ value: 'O valor padrão é "Em instalação".' }, { value: 'Em operação.' }, { value: 'Em modernização.' }, { value: 'Desinstalação Forçada.' }, { value: 'Desmobilizada.' }],
      [{ value: 'O endereço é convertido em Latitude e Longitude' }],
      [{ value: 'Ao colocar um novo valor, o valor antigo é sobrescrito' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: 'Ao colocar uma nova foto, a foto antiga é sobrescrita.' }],
      [{ value: '' }],
    ],
    environment: [
      [{ value: 'Restrições' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: 'Ao colocar um dispositivo que não existe, este é criado.' }, { value: 'Deve começar com DUT/DAM' }],
      [{ value: 'Ao colocar uma nova foto, a foto antiga é sobrescrita.' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: 'Para criar um ambiente, deve ser um nome diferente dos demais.' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
    ],
    utility: [
      [{ value: 'Restrições' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
      [{ value: '' }],
      [{ value: 'Ao colocar uma nova foto, a foto antiga é sobrescrita.' }],
      [{ value: 'Ao colocar uma nova foto, a foto antiga é sobrescrita.' }],
      [{ value: 'Deve ser um dos valores tabelados.' }],
    ],
  };

  const valuesDefault = {
    aplicationMachine: ['AR-CONDICIONADO', 'CÂMARA FRIA', 'CHILLER', 'Cortina de ar', 'FANCOIL', 'Trocador de Calor'],
    dutDuoSensors: ['Retorno, Insuflação', 'Insuflação, Retorno'],
    sensorsTypes: ['pliq', 'psuc', 'curr'],
    aplicationEnergy: ['Medidor de Energia', 'Splitão Inverter Hitachi', 'Splitão Inverter Carrier', 'Fancoil', 'VAV'],
    thermostatModels: [{ label: 'BAC-2000', value: 'BAC-2000' }, { label: 'BAC-6000', value: 'BAC-6000' }, { label: 'BAC-6000 AMLN', value: 'BAC-6000-AMLN' }],
    valveTypes: ['Válvula Proporcional 0-10V', 'Válvula Fixa On-Off'],
    hydrometerModels: ['Elster S120 (1 L/pulso)', 'ZENNER ETKD-P-N (10 L/pulso)', 'ZENNER MTKD-AM-I (10 L/pulso)', 'Saga Unijato US-1.5 (1 L/pulso)', 'Saga Unijato US-3.0 (1 L/pulso)', 'Saga Unijato US-5.0 (1 L/pulso)'],
    installationType: ['Para os modelos ET330, EM330 e EM210:', 'Rede Bifásica', 'Rede Trifásica sem neutro', 'Rede Trifásica com neutro'],
    inputVoltage: ['127', '220', '380'],
    outVoltage: ['127', '220'],
    tensaoRede: ['127', '220', '380'],
    deviceStatus: ['Em Operação', 'Máquina desenergizada', 'Desinstalação forçada', 'Dispositivo removido'],
    damInstallationLocation: ['Casa de Máquina', 'Ambiente Refrigerado', 'Outros'],
    damPlacement: [{ label: 'Retorno', value: 'RETURN' }, { label: 'DUO', value: 'DUO' }],
    damDuoSensors: [{ label: 'Retorno', value: 'RETURN' }, { label: 'Insuflação', value: 'INSUFFLATION' }],
    equipmentPower: ['380V / 3F / 60Hz', '220V / 3F / 60Hz', '220V / 1F / 60Hz'],
    utilityApplication: ['Iluminação', 'Nobreak', 'Elevador', 'Escada Rolante', 'Gerador', 'Alarme de Incêndio', 'Alarme de Intrusão', "Caixa D'água"],
  };

  function separateData() {
    if (comboOpts.units) {
      comboOpts.units.map((unit: {value: number, label: string}, index) => {
        if (index !== 0) {
          unitMachineIds.push(' ');
          unitMachineLabel.push(' ');
          unitMachineIds.push('x');
          unitMachineLabel.push('x');
          unitMachine.push('x');
        }
        unitMachine.push(unit.label);
        (comboOpts.groups || []).filter((x) => x.unit === unit.value).map((machine) => {
          unitMachineLabel.push(machine.label);
          unitMachineIds.push(String(machine.value));
          unitMachine.push(' ');
        });
      });
    }
  }

  async function getTimezones() {
    try {
      const { list } = await apiCall('/get-timezones-list-with-offset', {});
      setTimezonesList(list.map((item) => ({
        label: `${item.area} - (${item.offset})`,
        value: item.id,
      })));
    } catch (err) {
      console.log('error timezones');
    }
  }

  async function getCurrentSensor() {
    try {
      const { list } = await apiCall('/config/get-pressure-sensors', {});
      const formattedList = list.map((item) => ({ label: item.SENSOR_NAME, value: item.SENSOR_ID }));
      setSensorsPressure(formattedList);
    } catch (err) {
      console.log('error pressure sensors');
    }
  }

  async function getUtilitiesModels() {
    try {
      const modelsUtilities = await apiCall('/utilities/models', {});
      setUtilitiesModels(modelsUtilities);
    } catch (err) {
      console.log('error utilities models');
    }
  }

  async function getEnvironmentCategories() {
    try {
      const categoriesList = await apiCall('/dev/dev-info-combo-options', { environmentCategories: true });
      setEnvironmentCategories(categoriesList.environmentCategories);
    } catch (err) {
      console.log(err);
      toast.error(t('houveErro'));
    }
  }

  useEffect(() => {
    separateData();
    getTimezones();
    getCurrentSensor();
    getUtilitiesModels();
    getEnvironmentCategories();
  }, []);

  function getFlatUtilityNames(modelsByType): { value: string }[] {
    const result: { value: string }[] = [];

    for (const type in modelsByType) {
      const numericType = Number(type);
      const baseName = valuesDefault.utilityApplication[numericType - 1] || `Tipo ${numericType}`;
      result.push({ value: baseName }, ...modelsByType[numericType].map((model) => ({ value: model.name })), { value: ' ' }, { value: '-------------------------------------' });
    }

    return result;
  }

  function tranformeArrayInValue(array, type?: string) {
    if (array) {
      if (type === 'name') {
        return array.map((item) => ({ value: item.name }));
      }
      if (type === 'label') {
        return array.map((item) => ({ value: item.label }));
      }
      if (type === 'value') {
        return array.map((item) => ({ value: item.value }));
      }
      return array.map((item) => ({ value: item }));
    }
    return [{ value: '' }];
  }

  const valuesTable = {
    energy: [
      [{ value: 'Valores Tabelados' }],
      [{ value: 'Energia' }],
      tranformeArrayInValue(comboOpts.units, 'label'),
      tranformeArrayInValue(valuesDefault.aplicationEnergy),
      [{ value: '' }],
      [{ value: '' }],
      [{ value: 'QGBT' }, { value: 'QFAC' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      energyOpts ? energyOpts.map((row) => ({ value: row.NAME })) : [{ value: '' }],
      currentCapacityOpts,
      tranformeArrayInValue(valuesDefault.installationType),
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      tranformeArrayInValue(comboOpts.vavs, 'label'),
      tranformeArrayInValue(valuesDefault.thermostatModels, 'label'),
      tranformeArrayInValue(comboOpts.vavs, 'label'),
      [{ value: '' }],
      tranformeArrayInValue(valuesDefault.valveTypes),
      tranformeArrayInValue(comboOpts.vavs, 'label'),
      [{ value: '' }],
      tranformeArrayInValue(comboOpts.fancoilsManuf, 'label'),
      [{ value: '' }],
      tranformeArrayInValue(valuesDefault.deviceStatus),
    ],
    machine: [
      [{ value: 'Valores Tabelados' }],
      [{ value: 'Máquina' }],
      tranformeArrayInValue(unitMachine),
      tranformeArrayInValue(unitMachineIds),
      tranformeArrayInValue(unitMachineLabel),
      [{ value: '' }],
      [{ value: '' }],
      tranformeArrayInValue(valuesDefault.aplicationMachine),
      tranformeArrayInValue(comboOpts.types, 'label'),
      tranformeArrayInValue(comboOpts.brands, 'label'),
      tranformeArrayInValue(comboOpts.fluids, 'label'),
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      tranformeArrayInValue(comboOpts.dutPlacement, 'label'),
      tranformeArrayInValue(valuesDefault.dutDuoSensors),
      tranformeArrayInValue(valuesDefault.damInstallationLocation),
      tranformeArrayInValue(valuesDefault.damPlacement, 'label'),
      tranformeArrayInValue(valuesDefault.damDuoSensors, 'label'),
      tranformeArrayInValue(valuesDefault.damDuoSensors, 'label'),
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      comboOpts.rtypes ? comboOpts.rtypes.map((row) => ({ value: row.RTYPE_NAME })) : [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      tranformeArrayInValue(comboOpts.roles, 'label'),
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      tranformeArrayInValue(comboOpts.evaporatorModels, 'label'),
      [{ value: '' }],
      [{ value: '' }],
      tranformeArrayInValue(valuesDefault.equipmentPower),
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      tranformeArrayInValue(comboOpts.psens, 'label'),
      tranformeArrayInValue(valuesDefault.sensorsTypes),
      tranformeArrayInValue(comboOpts.psens, 'label'),
      tranformeArrayInValue(valuesDefault.sensorsTypes),
      [{ value: '' }],
      [{ value: '' }],
      tranformeArrayInValue(valuesDefault.deviceStatus),
    ],
    water: [
      [{ value: 'Valores Tabelados' }],
      [{ value: 'Água' }],
      tranformeArrayInValue(comboOpts.units, 'label'),
      [{ value: '' }],
      tranformeArrayInValue(valuesDefault.hydrometerModels),
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      tranformeArrayInValue(valuesDefault.deviceStatus),
    ],
    unit: [
      [{ value: 'Valores Tabelados' }],
      [{ value: 'Unidade' }],
      tranformeArrayInValue(comboOpts.units, 'value'),
      [{ value: '' }],
      [{ value: '' }],
      tranformeArrayInValue(comboOpts.units, 'label'),
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: 'Seg 08:00' }, { value: 'Ter 08:00' }, { value: 'Qua 08:00' }, { value: 'Qui 09:00' }],
      [{ value: 'Seg 17:00' }, { value: 'Ter 18:00' }, { value: 'Qua 18:00' }, { value: 'Qui 17:00' }],
      [{ value: '10/10/2025 10:00-18:00' }, { value: '10/10 10:00-18:00' }],
      tranformeArrayInValue(timezoneList, 'label'),
      [{ value: '' }],
      [{ value: 'Em produção' }, { value: 'Em instalação' }, { value: 'Em modernização' }, { value: 'Desinstalação Forçada' }, { value: 'Desmobilizada' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
    ],
    environment: [
      [{ value: 'Valores Tabelados' }],
      [{ value: 'Ambientes' }],
      tranformeArrayInValue(comboOpts.units, 'label'),
      [{ value: '' }],
      [{ value: '' }],
      tranformeArrayInValue(comboOpts.environments, 'value'),
      tranformeArrayInValue(comboOpts.environments, 'label'),
      comboOpts.rtypes ? comboOpts.rtypes.map((row) => ({ value: row.RTYPE_NAME })) : [{ value: '' }],
      tranformeArrayInValue(environmentCategories, 'label'),
    ],
    utility: [
      [{ value: 'Valores Tabelados' }],
      [{ value: 'Utilitário' }],
      tranformeArrayInValue(comboOpts.units, 'label'),
      tranformeArrayInValue(valuesDefault.utilityApplication),
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      getFlatUtilityNames(utilitiesModels),
      tranformeArrayInValue(valuesDefault.tensaoRede),
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      sensorsPressure,
      [{ value: '' }],
      [{ value: '' }],
      [{ value: '' }],
      tranformeArrayInValue(valuesDefault.deviceStatus),
    ],
  };

  return (
    <TableContainer>
      <Table>
        {
          typeOfSolution && (
            <>
              <ValuesTableTable valuesTable={typeSolutionHeader[typeOfSolution]} typeHeader={typeOfSolution.length > 0} typeOfSolution={typeOfSolution} />
              <tbody>
                <tr>
                  <ValuesTableTable valuesTable={required[typeOfSolution]} typeHeader={typeOfSolution.length < 0} typeOfSolution={typeOfSolution} />
                </tr>
                <tr>
                  <ValuesTableTable valuesTable={restrict[typeOfSolution]} typeHeader={typeOfSolution.length < 0} typeOfSolution={typeOfSolution} />
                </tr>
                <ValuesTableTable valuesTable={valuesTable[typeOfSolution]} typeHeader={typeOfSolution.length < 0} typeOfSolution={typeOfSolution} />
              </tbody>
            </>
          )
        }
      </Table>
    </TableContainer>
  );
};

function ValuesTableTable({ valuesTable, typeHeader, typeOfSolution }) {
  function verifyParam(value: { value: string | number }, index) {
    if (typeOfSolution === 'machine') {
      if (value.value === ' ') {
        return (
          <tr
            key={`params ${value.value} ${index}`}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'initial',
              textAlign: 'center',
              marginBottom: '22px',
            }}
          >
            {value.value}
          </tr>
        );
      }
      if (value.value === 'x') {
        return (
          <tr
            key={value.value}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'initial',
              textAlign: 'center',
              marginTop: '10px',
            }}
          />
        );
      }
      return (
        <tr
          key={`params ${value.value} ${index}`}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'initial',
            textAlign: 'center',
          }}
        >
          {value.value}
        </tr>
      );
    }
    return (
      <tr
        key={`params ${value.value} ${index}`}
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'initial',
          textAlign: 'center',
        }}
      >
        {value.value}
      </tr>
    );
  }

  function tableValuesCell(param: {value: string | number}[]) {
    return (
      <th style={{
        fontWeight: 'normal',
        alignItems: 'initial',
        textAlign: 'center',
        flexDirection: 'column',
      }}
      >
        { param?.map((value, index) => verifyParam(value, index)) }
      </th>
    );
  }

  function tableValuesHeader(param: {value: string | number}[]) {
    return (
      <th style={{
        alignItems: 'initial',
        textAlign: 'center',
        flexDirection: 'column',
      }}
      >
        { param.map((value, index) => (
          <tr
            key={`header ${value.value} ${index}`}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'initial',
              textAlign: 'center',
            }}
          >
            {value.value}
          </tr>
        ))}
      </th>
    );
  }

  if (typeHeader) {
    return (
      valuesTable.map((values) => (
        <>
          {tableValuesHeader(values)}
        </>
      ))
    );
  }

  return (
    valuesTable.map((values) => (
      <>
        {tableValuesCell(values)}
      </>
    ))
  );
}
